/* countdowntimer.js — soft-FOMO expiry + urgency classes */
customElements.get("countdown-timer") || customElements.define("countdown-timer", class extends HTMLElement {
  startDate = null;
  endDate = null;
  days = null; hrs = null; mins = null; secs = null;
  rafId = null;

  // extras
  bannerTextEl = null;
  expiredMessage = "New offer coming soon.";
  hideOnExpire = true; // hide the timer when expired
  last10hClass = "is-last-10h";
  last60mClass = "is-last-60m";
  expiredClass = "is-expired";

  constructor() { super(); }

  connectedCallback() {
    // Dates (accepts ISO with timezone; 'YYYY-MM-DD' assumed local midnight)
    this.startDate = this._parseDate(this.dataset.startDate);
    this.endDate   = this._parseDate(this.dataset.endDate);

    // Optional overrides
    if (this.dataset.expiredMessage) this.expiredMessage = this.dataset.expiredMessage;
    if (this.dataset.hideOnExpire === "false") this.hideOnExpire = false;

    // Find slots to update
    this.days = this.querySelector("[data-days]");
    this.hrs  = this.querySelector("[data-hrs]");
    this.mins = this.querySelector("[data-mins]");
    this.secs = this.querySelector("[data-secs]");

    // Try to find sibling announcement text within a common wrapper
    // (Works with the .annc-flex structure we used)
    const wrapper = this.closest(".annc-flex") || this.parentElement;
    if (wrapper) this.bannerTextEl = wrapper.querySelector(".annc-text");

    // Validate and start
    if (isNaN(this.startDate) || isNaN(this.endDate)) {
      console.error("[Countdown Timer] Invalid start or end date.");
      return;
    }

    // Prevent counting up before start
    const now = new Date().getTime();
    if (this.startDate < now) this.startDate = now;

    this._tick();
  }

  disconnectedCallback() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  _tick = () => {
    const now = Date.now();

    // compute remaining to start or end
    let target = (now < this.startDate) ? this.startDate : this.endDate;
    let remMs = Math.max(0, target - now);

    // Update UI or expire
    if (now >= this.endDate) {
      this._updateDisplay({ days:0, hours:0, minutes:0, seconds:0 });
      this._handleExpired();
      if (this.rafId) cancelAnimationFrame(this.rafId);
      return;
    } else {
      this._updateDisplay(this._breakdown(remMs));
    }

    // Urgency classes
    const TEN_HOURS = 10 * 60 * 60 * 1000;
    const ONE_HOUR  = 1  * 60 * 60 * 1000;
    this.classList.toggle(this.last10hClass, remMs <= TEN_HOURS && remMs > ONE_HOUR);
    this.classList.toggle(this.last60mClass, remMs <= ONE_HOUR && remMs > 0);

    this.rafId = requestAnimationFrame(this._tick);
  };

  _handleExpired() {
    this.classList.add(this.expiredClass);
    if (this.bannerTextEl) {
      this.bannerTextEl.textContent = this.expiredMessage;
    }
    if (this.hideOnExpire) {
      this.style.display = "none";
    }
  }

  _breakdown(ms) {
    const s = Math.floor(ms / 1000);
    const days = Math.floor(s / 86400);
    const hours = Math.floor((s % 86400) / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = s % 60;
    return { days, hours, minutes, seconds };
  }

  _updateDisplay({ days, hours, minutes, seconds }) {
    if (this.days) this.days.textContent = String(days).padStart(2, "0");
    if (this.hrs)  this.hrs.textContent  = String(hours).padStart(2, "0");
    if (this.mins) this.mins.textContent = String(minutes).padStart(2, "0");
    if (this.secs) this.secs.textContent = String(seconds).padStart(2, "0");
  }

  _parseDate(val) {
    if (!val) return NaN;
    // If 'YYYY-MM-DD' -> local midnight
    if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
      return new Date(val + "T00:00:00").getTime();
    }
    // Otherwise rely on native Date parsing (ISO with offset recommended)
    const d = new Date(val);
    return d.getTime();
  }
});
